module.exports = __webpack_public_path__ + "static/media/www.73ec8d98.jpg";